import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'form', 'fileForm', 'downloadCompletedTemplate', 'downloadRespondentTemplate', 'completedInput',
    'copiedTextButton', 'invitationDeliveryForm', 'reportDeliveryForm'
  ]

  toggleNewUserForm({ target }) {
    const hide = target.dataset.hide;
    const inviteUserForm = document.getElementById('new_user');
    inviteUserForm.classList.toggle('d-none', hide);
  }
  
  hideElement({ target: { dataset: { selector } } }) {
    $(`${selector}`).addClass('d-none');
  }

  toggleForm({ target: { dataset: { hide } } }) {
    this.formTarget.classList.toggle('d-none', hide);
  }

  toggleCustomSurveyLinkForm({ target: { dataset: { hide } } }) {
    const form = document.querySelector('#custom_survey_link_import_form .inline-form');
    if (form) {
      if (hide === 'true') {
        form.classList.add('d-none');
      } else {
        form.classList.remove('d-none');
      }
    }
  }

  toggleAttachForm({ target: { dataset: { hide } } }) {
    this.formTarget.classList.toggle('d-none', hide);
    if (hide === 'true') {
      this.formTarget.querySelector('#template-survey-selector').selectedIndex = 0;
      this.formTarget.querySelector('#languages-selector-wrapper').remove()
    }
  }

  toggleInvitationDeliveryForm({ target: { dataset: { hide } } }) {
    this.invitationDeliveryFormTarget.classList.toggle('d-none', hide);
  }

  toggleReportDeliveryForm({ target: { dataset: { hide } } }) {
    this.reportDeliveryFormTarget.classList.toggle('d-none', hide);
  }

  toggleFileForm({ target: { dataset } }) {
    const importType = dataset.importType
    const hide = dataset.hide

    if (importType !== undefined) {
      if (importType == 'completed') {
        this.downloadCompletedTemplateTarget.classList.remove('d-none')
        this.downloadRespondentTemplateTarget.classList.add('d-none')
        this.completedInputTarget.value = 1
      } else {
        this.downloadCompletedTemplateTarget.classList.add('d-none')
        this.downloadRespondentTemplateTarget.classList.remove('d-none')
        this.completedInputTarget.value = 0
      }
    }
    this.fileFormTarget.classList.toggle('d-none', hide);
  }

  removeTargetById({ target }) {
    document.getElementById(target.dataset.targetId).remove()
  }

  removeClosestTargetByClass(event) {
    event.preventDefault();
    const target = event.target;
    target.closest(`.${target.dataset.targetClass}`).remove();
  }

  copyText(event) {
    const copiedText = event.target.dataset.copiedText;

    document.dispatchEvent(
      new CustomEvent('show-flash', {
        detail: {
          role: 'success',
          message: 'Link has been copied successfully'
        }
      })
    )
    if (navigator && navigator.clipboard && navigator.clipboard.writeText)
      return navigator.clipboard.writeText(copiedText);
    else
      var textArea = document.createElement("textarea");
    textArea.value = copiedText;
    // make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      // here the magic happens
      document.execCommand('copy') ? res() : rej();
      textArea.remove();
    });
  }

  toggleCollapse(event) {
    const header = event.currentTarget;
    const content = header.nextElementSibling;
    const arrow = header.querySelector('.arrow');

    if (content.style.display === "none") {
      content.style.display = "block";
      if (arrow) arrow.textContent = "▼";
    } else {
      content.style.display = "none";
      if (arrow) arrow.textContent = "►";
    }
  }
}
